module.exports = __webpack_public_path__ + "static/img/4_1_3.52d5f0a3.jpg";